<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <div class="card">
            <div class="card-body">
                <!-- <img style="width:100%;height: auto;" src="../../../edozzier/{{doc}}" /> -->
                <img style="width:100%;height: auto;" src="{{doc.doc_path}}" *ngIf="doc.doc_type == 'image'"/>
                <a mat-raised-button title="Download" href="{{doc.doc_path}}" download *ngIf="doc.doc_type == 'pdf'">
                  <mat-icon>get_app</mat-icon>
                </a>
                <audio controls *ngIf="doc.doc_path == 'music'">
                  <source src="{{doc.doc_path}}"/>
                </audio>
                <video controls *ngIf="doc.doc_path == 'video'">
                  <source src="{{doc.doc_path}}"/>
                </video>
            </div>
        </div>
      </div>
    </div>
</div>
